import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class SubscriptionChangeAttributes {
  id: string = null;
  currentPhaseEndDate: string = null;
}

export class SubscriptionChangeBelongsTo {}
export class SubscriptionChangeHasOne {}
export class SubscriptionChangeHasMany {}

/**
 * Utility interfaces
 */
export interface SubscriptionChangeMethods {}

export interface SubscriptionChangeInterface
  extends SubscriptionChangeAttributes,
    SubscriptionChangeType {}

type SubscriptionChangeType = GConstructor<SubscriptionChangeInterface>;

export interface SubscriptionChangeResource
  extends Base<SubscriptionChangeAttributes>,
    SubscriptionChangeInterface,
    SubscriptionChangeMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<SubscriptionChangeAttributes>({
    queryName: 'subscription_changes',
    className: 'SubscriptionChange',
    AttributesClass: SubscriptionChangeAttributes,
  });

export const SubscriptionChangeResourceClass = <TBase extends SubscriptionChangeType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements SubscriptionChangeMethods {};

export class SubscriptionChangeResource extends ClassExtender<SubscriptionChangeInterface>(
  BaseClass,
  SubscriptionChangeResourceClass,
) {}

/**
 * Resource instance
 */
export const SubscriptionChange = APILibrary.createResource<SubscriptionChangeResource>(
  SubscriptionChangeResource,
);
